const specificationsStringify = (specifications) => {
  return Object.entries(specifications)
    .map(([id, optionIds]) => {
      return id + ":" + optionIds.join(",");
    })
    .join(";");
};

export const filterConfig = {
  categoryId: {
    state: {
      encode: () => {
        return undefined;
      },
      decode: (value) => {
        return value;
      },
    },
    request: {
      encode: (value) => {
        return value;
      },
    },
  },
  page: {
    state: {
      encode: (value) => {
        if (1 !== value) {
          return value;
        }
      },
      decode: (value) => {
        return parseInt(value);
      },
    },
    request: {
      encode: (value) => {
        return parseInt(value);
      },
      alias: "pageNum",
    },
  },
  limit: {
    state: {
      encode: (value) => {
        if (24 !== value) {
          return value;
        }
      },
      decode: (value) => {
        return parseInt(value);
      },
    },
    request: {
      encode: (value) => {
        return parseInt(value);
      },
      alias: "pageSize",
    },
  },
  specifications: {
    state: {
      encode: (value) => {
        if (Object.keys(value).length > 0) {
          return specificationsStringify(value);
        }
      },
      decode: (value) => {
        if (Object.keys(value).length > 0) {
          const specifications = {};

          value.split(";").forEach((specification) => {
            const [id, options] = specification.split(":");

            if (0 !== id.length && 0 !== options.length) {
              specifications[id] = options.split(",");
            }
          });

          return specifications;
        }

        return {};
      },
    },
    request: {
      encode: (value) => {
        if (0 === Object.keys(value).length) {
          return;
        }

        return specificationsStringify(value);
      },
    },
  },
  minPrice: {
    state: {
      encode: (value) => {
        if (undefined !== value) {
          return parseInt(value);
        }
      },
      decode: (value) => {
        if (value.length > 0 && 0 !== parseInt(value)) {
          return parseInt(value);
        }
      },
    },
  },
  maxPrice: {
    state: {
      encode: (value) => {
        if (undefined !== value) {
          return parseInt(value);
        }
      },
      decode: (value) => {
        if (value.length > 0 && 0 !== parseInt(value)) {
          return parseInt(value);
        }
      },
    },
  },
  labels: {
    state: {
      encode: (value) => {
        if (value.length > 0) {
          return value.join(",");
        }
      },
      decode: (value) => {
        return value.split(",");
      },
    },
    request: {
      encode: (value) => {
        if (value.length > 0) {
          return value;
        }
      },
    },
  },
  sort: {
    state: {
      encode: (value) => {
        if (undefined !== value) {
          return value;
        }
      },
      decode: (value) => {
        if (value.length > 0) {
          return value;
        }
      },
    },
  },
  searchQuery: {
    state: {
      encode: (value) => {
        if (undefined !== value) {
          return value;
        }
      },
      decode: (value) => {
        if (value.length > 0) {
          return value;
        }
      },
    },
  },
};
